import React from 'react'

export default function ClassOptions({
  defaultClassName,
  selectedClass,
  classes,
  onChangeFundClass,
  section,
}) {
  const onChangeFundClassDropdown = (event) => {
    onChangeFundClass(event)
  }

  return (
    <div className="u-lg-flex u-lg-flexAlignItemsCenter u-sm-marginBottom4gu">
      <label
        className="Form-label u-marginBottom0 u-sm-hiddenVisually"
        htmlFor={`class-dropdown-${section}`}
      >
        Class
      </label>
      <div className="Dropdown u-sm-marginLeft0 u-md-marginLeft0 u-marginLeft2gu">
        <select
          id={`class-dropdown-${section}`}
          value={(selectedClass && selectedClass.className) || defaultClassName}
          className="Dropdown-menu"
          data-qa-automation={'classDropdown'}
          onChange={onChangeFundClassDropdown}
        >
          {classes && classes.length > 0
            ? classes.map((fundClass) => {
                return (
                  <option key={fundClass.className} value={fundClass.className}>
                    {fundClass.className}
                  </option>
                )
              })
            : null}
        </select>
      </div>
    </div>
  )
}
